export const SET_CURRENT_CALL_FOR_COMPETITION =
  "Setzt die Current Id d. Call For Competition";

export const SET_CALLS_FOR_COMPETITION = "Setze alle Calls for Competition";
export const SET_LOCK = "Setze das callForCompetition Lock";
